<template>
  <layout-login>
    <h2 class="invite-title">
      {{ $t('message["471"]') }}<span
        class="invite-company"
        v-text="comname"
      />
    </h2>
    <div>
      <cube-form
        :model="model"
        :options="options"
        @validate="validateHandler"
        @submit.prevent="submitHandler"
      >
        <cube-form-item :field="fields[0]" />
        <div class="cube-form-item-box">
          <cube-form-item :field="fields[1]" />
          <div class="find-pwd-box">
            <get-code
              class="find-pwd-link"
              :mobile="model.mobile"
              type="10"
              :is-disabled="sDisabled"
              @getRes="getCode"
            />
          </div>
        </div>
        <cube-form-group>
          <cube-button
            type="submit"
            :primary="true"
            :disabled="sDisabled"
          >
            {{ $t('message["597"]') }}
          </cube-button>
        </cube-form-group>
      </cube-form>
    </div>
  </layout-login>
</template>

<script type="text/ecmascript-6">
import LayoutLogin from '@/components/mobile/account/LayoutLogin'
import GetCode from '@/components/mobile/GetCode'
import { mapActions } from 'vuex'
import { setAuth } from '@/lib/storage'
import { options, loginFields } from '@/components/mobile/invite/common'
export default {
  components: {
    LayoutLogin,
    GetCode
  },
  data () {
    return {
      isValid: false,
      sDisabled: true,
      model: {
        mobile: '',
        checkcode: ''
      },
      options,
      inviteLogin: {
        checkuserid: '',
        isreg: 0,
        invitecode: this.$route.query.invitecode
      },
      fields: loginFields
    }
  },
  computed: {
    comname () {
      return this.$route.query.comname
    }
  },
  methods: {
    ...mapActions('organization/inviteJoin', ['ajaxJoin', 'ajaxLastJoin']),
    async submitHandler (e) {
      if (this.isValid) {
        let params = Object.assign(this.model, this.inviteLogin)
        const chain = await this.ajaxJoin()
        const _this = this
        chain.params(params)
          .onSuccess(async (raw, res) => {
            if (!res.error) {
              const { isreg, Authorization } = res.payload
              if (!isreg) {
              // 未注册
                _this.$router.push({ path: '/organization/invitejoin2',
                  query: {
                    invitecode: _this.$route.query.invitecode,
                    mobile: _this.model.mobile,
                    ensecret: res.payload.ensecret
                  } })
              } else {
                setAuth(Authorization)
                await _this.$store.commit('setAuth', Authorization, { root: true })
                const chain = await _this.ajaxLastJoin()
                chain.params({ invitecode: _this.$route.query.invitecode })
                  .onSuccess((raw, res) => {
                    if (!res.error) {
                      _this.$router.push({ name: 'OrgIndex' })
                    }
                  })
                  .fetch()
              }
            }
          })
          .setForm(_this.form)
          .fetch()
      }
    },
    getCode (result) {
      this.inviteLogin.checkuserid = result.checkuserid
    },
    validateHandler (result) {
      const { valid } = result
      this.isValid = valid
      this.sDisabled = !this.isValid
    }
  }
}
</script>

<style scoped lang="scss">
.invite-title {
  width: 279px;
  margin: 30px auto;
}
.invite-title, .invite-company {
  color: #333;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  .invite-company {
    margin: 0 5px;
  }
}
</style>
